// Business model section configuration
// Defines fields for revenue model and pricing
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for business model section
export const businessModelSectionSchema = z.object({
  revenueGeneration: z.string().min(1, 'Este campo es requerido'),
  whoPays: z.string().min(1, 'Este campo es requerido'),
  averageTicket: z.string().min(1, 'Este campo es requerido'),
  revenueSources: z.array(z.string()).optional(),
});

export type BusinessModelSectionData = z.infer<typeof businessModelSectionSchema>;

// Section config
export const businessModelSection: SectionConfig = {
  id: 'business-model',
  titleKey: 'Modelo de negocio',
  descriptionKey: 'Define cómo genera ingresos tu startup',
  validationSchema: businessModelSectionSchema,
  fields: [
    {
      name: 'revenueGeneration',
      type: 'textarea',
      label: '¿Cómo genera ingresos tu startup?',
      placeholder: 'Describe tu modelo de monetización...',
      required: true,
    },
    {
      name: 'whoPays',
      type: 'textarea',
      label: '¿Quién paga por tu solución?',
      placeholder: 'Describe quién es tu cliente pagador...',
      required: true,
    },
    {
      name: 'averageTicket',
      type: 'text',
      label: 'Precio o ticket promedio',
      placeholder: 'Ej: $50/mes, $500/año...',
      required: true,
    },
    {
      name: 'revenueSources',
      type: 'multiselect',
      label: 'Principales fuentes de ingresos',
      required: false,
      options: [
        { value: 'pilots', label: 'Pilotos' },
        { value: 'trials', label: 'Pruebas' },
        { value: 'contracts', label: 'Contratos activos' },
      ],
    },
  ],
};
